@if (items?.length > 0) {
  <div class="global-search-section-wrapper">
    <div class="global-search-panel-header">
      <div class="global-search-title">{{ sectionName }}</div>
    </div>
    <mat-nav-list class="global-search-panel-content">
      @for (item of items; track item; let i = $index) {
        <a
          isGlobalSearchFocused
          mat-list-item
          [aria-label]="item.title"
          [id]="'global-search-' + idPrefix + '-result-' + i"
          [ngClass]="{ 'global-search-item': true, 'global-search-item-subtitle': !item.subtitle }"
          [routerLink]="item.routerLink"
          (click)="onClick()"
          >
          <div class="global-search-item-container">
            <div class="global-search-item-title">
              @if (item.searchType === 'PhoneNumber') {
                {{ item.title | formatPhoneNumbers }}
              } @else {
                <ng-container>
                  {{ item.title }}
                </ng-container>
              }
            </div>
            @if (item.subtitle) {
              <div class="global-search-item-subtitle">{{ item.subtitle }}
              </div>
            }
          </div>
        </a>
      }
    </mat-nav-list>
  </div>
}
